import React from 'react';
import '../styles/sections/iconsWithHeadingText.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';

function IconsWithHeadingText(props) { 
    const data = props.data;
    return (
        <div className="iconsWithHeadingText">
            <div className="innerBox">
                {data.subheading && 
                    <h4 className="sectionSubHeading">{data.subheading}</h4>
                }
                {data.title && 
                    <h3 className="sectionHeading">{data.title}</h3>
                }
                <ul>
                    {data.blocks.map((d,i) =>
                        <li key={i}>
                            <LazyLoadImage
                                alt={d.heading}
                                effect="blur"
                                src={d.src} // use normal <img> attributes as props
                                /> 
                            <h6>{d.heading}</h6>
                            <span>{d.content}</span>
                        </li>
                    )}
                </ul>
            </div>        
        </div>
    )
};

export default IconsWithHeadingText; 